import { render, staticRenderFns } from "./c_Creator_Events_Item_Tickets.vue?vue&type=template&id=008df958&scoped=true&"
import script from "./c_Creator_Events_Item_Tickets.vue?vue&type=script&lang=js&"
export * from "./c_Creator_Events_Item_Tickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008df958",
  null
  
)

export default component.exports